import React, {useEffect, useState} from 'react';
import {Table, TableBody, TableCell, TableHead, TableHeader, TableRow} from "../../shadCn/components/ui/table";
import {useNavigate} from "react-router-dom";
import PaginationCustom from "./PaginationCustom";
import NoImage from "../../resources/icon/noImage.png";
import FilterBasic from "../filter/FilterBasic";
import EmptyData from "../../resources/icon/empty-data.png"
import {Button} from "../../shadCn/components/ui/button";
import {checkOutComputerRoom} from "../../api/computerRoom/ComputerRoomService";
import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";
import {useSelector} from "react-redux";

/**
 * `테이블 `기본테이블
 * header: 테이블 헤더의 각 칼럼명
 * option: 옵션 => 행 클릭시 이동할 주소, 테이블이 화면상에서 차지할 넓이
 * data: 리소스 서버에서 가져온 리스트
 * paged : {pageable, setPageable} => pageable : 페이지 정보(스프링의 pegable 객체)  /  paged.setPageable : 페이지 네이션에 의해 조작되는 페이지 정보를 세팅할 메서드
 * size : 한페이지에 몇개의 컨텐츠 표시되는지.
 * checked : {checked, setChecked}} => 체크된 값( data.id )을 넘겨줌.
 * button : {text : [], listener : [], class : []} 버튼이 있는 td는 상세페이지 이동 비활성화
 * img : true, false로 사용유무 제여
 *  @@ header @@
 *  {name: "이름", field: "key", width: 18, minWidth: 250} => data.key 를 "이름" 이라는 칼럼에 넓이 18% 이고 최소로는 250px 차지하도록 한다.  이런식으로 각 칼럼에 대한 정보를 배열로 넘기면 된다.
 *  notUse {checkbox : true, number : true} 각 필드별로 true를 걸면 해당 필드가 설정되지 않도록 설정
 *  removeLink : true > 모든행의 링크기능 제거
 * */

function TableComputerRoom({ Listener,header, option, data, paged, checked, size, notUse, removeLink, onRowClick}) {
    const status = useSelector(state => state.api.status);
    const user = useSelector((state) => state.auth.user);
    const IMG_BASE = import.meta.env.VITE_IMG_BASE

    const [filterOpen, setFilterOpen]= useState(false); // 필터 팝업여부
    const [tableTh, setTableTh]=useState(header);

    const navigate = useNavigate();
    const movePage = (id) => {
        // let state;
        // if(option.state)
        //     state = option.state;
        // else
        //     state = {id : id}
        // navigate(
        //     `${option.url}/${id}`,
        //     { state: state }
        // );
    }
    const [isHeaderChecked, setIsHeaderChecked] = useState(false);

    const handleHeaderCheckboxClick =()=>{
        setIsHeaderChecked(prev => !prev);
        if (!isHeaderChecked) {
            const currentPageIds = data.map((item) => item.id);
            checked.setChecked((prevItems) => [...new Set([...prevItems, ...currentPageIds])]);
        } else {
            const currentPageIds = data.map((item) => item.id);
            checked.setChecked((prevItems) => prevItems.filter((item) => !currentPageIds.includes(item)));
        }
    }

    const handleCheckboxClick = (value) => {
        const isChecked = checked.checked && checked.checked.includes(value);
        if (isChecked) {
            checked.setChecked((prevItems) => prevItems.filter((item) => item !== value));
        } else {
            checked.setChecked((prevItems) => [...prevItems, value]);
        }
        updateHeaderChkbox();
        }

    function updateHeaderChkbox() {
        if (data && data.length > 0) {
        const allChecked = data.every((item) => checked.checked.includes(item.id));
        setIsHeaderChecked(allChecked);
        } else {
            setIsHeaderChecked(false);
        }
    };

    const filterListener=()=>{
        setFilterOpen(!filterOpen)
    }
    const ttest=()=>{
        console.log(tableTh)
    }

    useEffect(() => {
    }, [data]);
    const getCurrentDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const handleTimeSelect = () => {
        const input = prompt("퇴실 시간을 입력해주세요 (예: YYYY-MM-DD hh:mm:ss)", getCurrentDateTime());

        // 입력값 검증
        if (input) {
            const dateRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
            if (dateRegex.test(input)) {
                console.log("선택된 시간:", input);
                // 여기서 추가 처리
                return input;
            } else {
                alert("올바른 형식으로 입력해주세요 (YYYY-MM-DD hh:mm:ss)");
            }
        }
    };



    const setCheckOut = async(id)=>{
        const regPhone = /^01([0|1|6|7|8|9])-([0-9]{3,4})-([0-9]{4})$/;
        if(user?.auth.includes("ROLE_ADMIN")){
            //관리자일때 실행
            let result = window.confirm("현재시간으로 퇴실시처리 하시겠습니까?");

            if (result) {
                const response = await checkOutComputerRoom(id, "now");

                if (response.status === 200) {
                    handleActiveToast({
                        message: "퇴실 완료 되었습니다.", labelListener: () => {
                        }
                    });
                    Listener();

                } else {
                    handleActiveError({message: "실패하였습니다."});

                }
            }else{
                const time =  handleTimeSelect();

                if (time){
                    const response = await checkOutComputerRoom(id, "input",time);

                    if (response.status === 200) {
                        handleActiveToast({
                            message: "퇴실 완료 되었습니다.", labelListener: () => {
                            }
                        });
                        Listener();

                    }else {
                        handleActiveError({message: "실패하였습니다."});

                    }
                }

            }

        }else {
            //관리자가 아닐때 실행
            const value = prompt("연락처를 입력하세요");

            if (value === "") {
                alert("연락처를 입력하세요.");
                return;
            } else if (value == null) {
            } else {


                const response = await checkOutComputerRoom(id, value);

                if (response.status === 200) {


                    handleActiveToast({
                        message: "퇴실 완료 되었습니다.", labelListener: () => {
                        }
                    });
                    Listener();


                } else if (response.status === 404) {
                    handleActiveError({message: "전화번호가 일치하지 않습니다."});
                } else {
                    handleActiveError({message: "실패하였습니다."});
                }

            }
        }
    }

    // 행 클릭 처리 함수 수정
    const handleRowClick = (item) => {
        if (onRowClick) {
            onRowClick(item);  // 재작성 모달 열기
        } else if (!removeLink) {
            movePage(item.id);  // 기존 상세페이지 이동
        }
    };

    return (
        <div style={{width: option.width+`%`}} >
            <div className="mb-2 relative text-left">
                <span className="totalElements" onClick={ttest}>
                총 {paged.pageable.totalElements} 건
                </span>
                <div className="inline-block float-right" onClick={filterListener}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                         stroke="currentColor" className="w-6 h-6 inline-block">
                        <path strokeLinecap="round" strokeLinejoin="round"
                              d="M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5"/>
                    </svg>
                </div>
                {filterOpen &&
                    <FilterBasic data={{data:header ,th:tableTh, fnc:setTableTh}} setFilterOpen={setFilterOpen}/>
                }
            </div>
            <div className="h-[386px]">

            <Table className="table-border common-table">
                <TableHeader className="table-head">
                    <tr className="table-head-row">
                        {!notUse?.checkbox &&
                            <td style={{width:'40px'}} className="text-center chk-box-col" >
                                <input
                                    checked={isHeaderChecked}
                                    onChange={handleHeaderCheckboxClick}
                                    type={"checkbox"}/>
                            </td>
                        }
                        {!notUse?.number &&
                            <TableHead  className="common-table-th text-center text-[12px]" style={{width:'40px'}}>No.</TableHead>
                        }

                        {tableTh.map((th, index) => {
                            const styles = {};
                            if (th.width && !th.exWidth) {
                                styles.width = th.width+`%`;
                            }
                            if (th.minWidth) {
                                styles.minWidth = th.minWidth +`px`;
                            }if (th.exWidth) {
                                styles.width = th.exWidth +`px`;
                            }
                            return (
                                <TableHead className="common-table-th text-center" key={index} style={styles}>
                                    {th.name}
                                    {/*{! th.exSort &&*/}
                                    {/*    < SortBasic target={th.field} paged={paged}/>*/}
                                    {/*}*/}
                                </TableHead>
                            );
                        })}
                    </tr>
                </TableHeader>
                <TableBody className="table-body text-center">
                    {data && data.length > 0 ? (data.map((item, rowIndex) => (
                    <TableRow key={rowIndex} onClick={removeLink ? (e) => { e.stopPropagation()} : () => handleRowClick(item)} className="cursor-pointer">
                        {!notUse?.checkbox &&
                            <td className="text-center  chk-box-col " onClick={(e) => {
                                e.stopPropagation();
                                handleCheckboxClick(item.id)
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={checked.checked && checked.checked.includes(item.id)}
                                    onChange={() => (item.id)}
                                />
                            </td>
                        }
                        {!notUse?.number &&
                            <td  className="text-center td-br h-[40px]" >{paged.pageable.page * size + rowIndex +1}</td>
                        }
                        {tableTh.map((th, colIndex) => (
                        <TableCell  className="border-1-e2e" key={colIndex}>
                            {th.field === 'phoneNumber' && item[th.field]? (
                                // item[th.field].slice(0, -4) + '****'

                                item[th.field].length === 11 ?
                                    item[th.field].substring(0, 3) + '-' + '****' + '-' + item[th.field].substring(7) :
                                    item[th.field].substring(0, 3) + '-' + '***' + '-' + item[th.field].substring(6)
                            ) : (

                            th.field === 'checkOutAt' ? (
                                // 퇴실 시간이 있으면 시간 표시
                                item.checkOutAt ? (
                                    item.checkOutAt
                                ) : (
                                    // 퇴실 시간이 없으면 결재상태에 따라 분기
                                    item.approvalType === '대기' ? (
                                        <span className="text-blue-600 font-medium">결재중</span>
                                    ) : item.approvalType === '반려' ? (
                                        <span className="text-red-600 font-medium">입실불가</span>
                                    ) : (
                                        <Button type="button" variant="outline"
                                                className="bg-orange-400 hover:bg-orange-300 text-white hover:text-white h-[25px] text-center"
                                                onClick={(e) => {
                                                    e.stopPropagation();  // ✅ 행 클릭 이벤트 방지 추가
                                                    setCheckOut(item.id);
                                                }}>
                                            퇴실하기
                                        </Button>
                                    )
                                )
                            ) : (
                                <>
                            {
                            Array.isArray(th.field)
                                ?
                                <>
                                {th.field.map((each,index)=>
                                    Array.isArray(tableTh[colIndex].label) ?
                                        <p key={index}>{item[th.field[index]] && typeof item[th.field[index]] === 'object' ?
                                            tableTh[colIndex].label[index]+" : "+(item[th.field[index]].name ? item[th.field[index]].name : '') :
                                            tableTh[colIndex].label[index]+" : "+(item[th.field[index]] ? item[th.field[index]] : '')
                                        }</p>
                                        : <p key={index}>{item[th.field[index]] && typeof item[th.field[index]] === 'object' ? item[th.field[index]].name: item[th.field[index]] }</p>
                                )}
                                </>
                                : (item[th.field] && typeof item[th.field] === 'object' ? item[th.field].name : item[th.field])
                            }

                            {
                                th.button &&
                                    <>
                                        {th.button.text.map((each,index)=>
                                            <div className={th.button.class[index]}  onClick ={th.button.listener[index]}>{th.button.text[index]}</div>
                                        )}
                                    </>
                            }

                            {
                                // uploadName,thumbnail, path
                                th.img &&
                                (item[th.field] ?
                                    <div className="w-[40px] p-[3px]">
                                    <img className="w-[40px] block " src={
                                        item[th.field][0].thumbnail && item[th.field][0].thumbnail ? IMG_BASE + item[th.field][0].path + "thumb_"+item[th.field][0].uploadName :
                                            IMG_BASE + item[th.field][0].path +item[th.field][0].uploadName
                                    } alt={"이미지 설명"} />
                                    </div>
                                 :
                                    <div className="w-[40px] h-[40px] p-[3px]">
                                        <img className="w-[40px] align-middle" src={NoImage} alt={"이미지 설명"} />
                                    </div>
                                )
                            }
                            </>
                                )
                                )}
                        </TableCell>
                            ))}
                    </TableRow>
                            ))
                    ):(
                        <>
                            <TableRow className="common-table-nodata-tr">
                                <TableCell className="table-no-data text-center" colSpan={ !notUse? tableTh.length+2 :
                                        notUse?.checkbox && notUse?.number ? tableTh.length :
                                        notUse?.checkbox || notUse?.number ? tableTh.length + 1 : tableTh.length+2}>
                                    <img src={EmptyData} className="w-[70px] m-auto mb-3"/>
                                    <span className="">내역이 없습니다.</span>
                                </TableCell>
                            </TableRow>
                        </>
                    )}
                </TableBody>
            </Table>
            </div>
            {data && data.length > 0 && (paged.totalPages > 1 || paged.pageable?.totalPages > 1) &&
                < PaginationCustom paged={paged} />
            }

        </div>
    );
}

export default TableComputerRoom;